import React, { useEffect, useState } from 'react';
import './SellerOptions.css';
import { FaPlay } from 'react-icons/fa';
import logo from '../assets/logo.png';
import { collection, getDocs } from 'firebase/firestore';
import { db } from '../../src/firebaseConfig';

const Tutorials = () => {
  const [tutorials, setTutorials] = useState([]);

  useEffect(() => {
    const fetchTutorials = async () => {
      try {
        const tutorialsRef = collection(db, 'Tutoriales');
        const snapshot = await getDocs(tutorialsRef);
        const data = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
        setTutorials(data);
      } catch (error) {
        console.error('Error al cargar tutoriales:', error);
      }
    };

    fetchTutorials();
  }, []);

  return (
    <div className="seller-options">
      <img src={logo} alt="Logo de BearMax" className="company-logo" />
      <h1 className="title">Tutoriales Disponibles</h1>
      <p className="subtitle">Explora nuestra colección de tutoriales prácticos con videos explicativos.</p>

      <div className="options-container">
        {tutorials.map((tutorial, index) => (
          <div className="option-card" key={index}>
            <div className="icon" style={{ cursor: 'pointer' }} onClick={() => window.open(tutorial.youtubeUrl, '_blank')}>
              <FaPlay />
            </div>
            <h3>{tutorial.title}</h3>
            <p>{tutorial.description}</p>
            <div style={{ textAlign: 'left', marginBottom: '15px' }}>
              <strong>Enlaces:</strong>
              <ul style={{ paddingLeft: '20px' }}>
                {tutorial.links?.map((link, i) => (
                  <li key={i}>
                    <a href={link} target="_blank" rel="noopener noreferrer" style={{ color: '#61dafb' }}>
                      {link}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
            <button className="btn" onClick={() => window.open(tutorial.youtubeUrl, '_blank')}>Ver Video</button>
          </div>
        ))}
      </div>

      <div className="options-container">
        <button className="go-back-btn" onClick={() => window.history.back()}>
          ← Regresar
        </button>
      </div>

      <div className="options-container">
        <footer className="footer">
          <p>© {new Date().getFullYear()} BearMax - Todos los derechos reservados</p>
        </footer>
      </div>
    </div>
  );
};

export default Tutorials;
